<!--
 * @Author: vince
 * @Date: 2021-08-15 14:01:12
 * @LastEditors: vince
 * @LastEditTime: 2021-08-16 09:44:09
 * @Description: 
-->
<template>
	<div>
		<div class="state-bar pr-md">
			<el-menu :default-active="activeIndex" active-text-color="#409EFF" mode="horizontal" @select="onTabClick">
				<el-menu-item index="1">进行中</el-menu-item>
				<el-menu-item index="2">未开始</el-menu-item>
				<el-menu-item index="3">已结束</el-menu-item>
			</el-menu>
			<el-button type="primary" icon="el-icon-plus">新增教育工作活动</el-button>
		</div>
		<div class="filter-bar">
			<el-form :inline="true" :model="filterFrom">
				<el-select v-model="filterFrom.region" placeholder="教育工作活动类型">
					<el-option label="区域一" value="shanghai"></el-option>
				</el-select>

				<el-form-item label="活动性质" prop="type">
					<el-checkbox-group v-model="filterFrom.type">
						<el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
						<el-checkbox label="地推活动" name="type"></el-checkbox>
						<el-checkbox label="线下主题活动" name="type"></el-checkbox>
						<el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="搜索" prop="name">
					<el-input v-model="filterFrom.keywork">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
export default {
	name: "educationalActivities",
	data() {
		return {
			activeName: "1",
			filterFrom: {}
		};
	},
	methods: {
		onTabClick() {}
	}
};
</script>

<style>
</style>